import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-sobre">
            <div className="footer-logo">
              <div className="footer-diamante"><span>★</span></div>
              <div>
                <span className="footer-nome">licmab</span>
                <span className="footer-sub">Liga Cultural de Marabá</span>
              </div>
            </div>
            <p className="footer-descricao">
              Promovendo cultura, tradição e inclusão social em Marabá, Pará. 
              Juntos somos mais fortes!
            </p>
            <p className="footer-cnpj">CNPJ: 24.603.962/0001-01</p>
          </div>

          <div className="footer-col">
            <h4>Navegação</h4>
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><Link to="/sobre">Sobre a LICMAB</Link></li>
              <li><Link to="/transparencia">Transparência</Link></li>
              <li><Link to="/eventos">Eventos</Link></li>
              <li><Link to="/festejo">Festejo Junino</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contato</h4>
            <ul>
              <li>Marabá, Pará</li>
              <li>Folha 08 Qd 03 Lote 12</li>
              <li>Nova Marabá</li>
              <li>CEP: 68.512.390</li>
            </ul>
          </div>
        </div>

        <div className="footer-rodape">
          <p>© {new Date().getFullYear()} LICMAB - Liga Cultural de Marabá. Todos os direitos reservados.</p>
          <p className="footer-slogan">Juntos Somos Mais Fortes ★</p>
        </div>
      </div>
    </footer>
  );
}
